export default import.meta.ROLLUP_FILE_URL_sJseK9w1g_oI6foJtHutsg